import { render, staticRenderFns } from "./version_management.vue?vue&type=template&id=ea400c32&"
import script from "./version_management.vue?vue&type=script&lang=js&"
export * from "./version_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports